import { HEADERS, onboardingApi } from ".";

type UserInfoResponse = {
	bankIdUser: {
		bankIdNumber: string;
		correspondenceName: string;
		firstName: string;
		lastName: string;
	};
	bearerToken: string;
	psus: Array<unknown>; // todo: fix
	refreshToken: string;
};

const loginApiSlice = onboardingApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchUserInfo: builder.query<UserInfoResponse, void>({
			query: () => ({
				url: "/auth/user-info",
				method: "GET",
				headers: {
					...HEADERS,
				},
			}),
			extraOptions: { withAuth: true },
		}),
	}),
	overrideExisting: false,
});

export const { useFetchUserInfoQuery } = loginApiSlice;
